// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__jmPil","file":"styles_file__1zH-8"};